import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import SettingsButton from './components/SettingsButton';
import AdminRoute from './components/AdminRoute';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import WhoWeAre from './pages/WhoWeAre';
import Partners from './pages/Partners';
import Careers from './pages/Careers';
import Join from './pages/Join';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import Agenda from './pages/Agenda';
import NotFound from './pages/NotFound';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/join" element={<Join />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <Dashboard />
                </AdminRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        
        {/* Fixed position elements */}
        <div className="fixed bottom-4 right-4 z-50">
          <ChatBot />
        </div>
        <SettingsButton />
      </div>
    </Router>
  );
}

export default App;